import { createTheme, Theme } from '@mui/material';

import { globalTheme } from '../../../../../shared/theme/theme';

export const modalTheme: Theme = createTheme(globalTheme, {
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          width: '584px',
          padding: '48px',
          borderRadius: '8px',
          boxSizing: 'border-box',
        },
      },
    },

    MuiDialogTitle: {
      styleOverrides: {
        root: {
          height: '28px',
          fontSize: '24px',
          fontWeight: 300,
          lineHeight: 'normal',
          padding: '0 0 30px 0',
        },
      },
    },

    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: 'unset',
        },
      },
    },

    MuiDialogContentText: {
      styleOverrides: {
        root: {
          width: '352px',
          height: '21px',
          marginBottom: '32px',
          fontSize: '18px',
          fontWeight: 300,
          fontStretch: 'normal',
          lineHeight: 'normal',
          letterSpacing: 'normal',
          color: globalTheme.palette.black.main,
        },
      },
    },

    MuiDialogActions: {
      styleOverrides: {
        root: { justifyContent: 'space-between', padding: 'unset' },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          '&.dialog-btn': {
            width: '236px',
            height: '56px',
            borderRadius: '4px',
            '&-no': {
              backgroundColor: globalTheme.palette.primary.main,
              '&:hover': {
                backgroundColor: globalTheme.palette.primary.main,
              },
            },

            '&-yes': {
              border: `solid 1px ${globalTheme.palette.appGrey.lightSilver}`,
              backgroundColor: globalTheme.palette.appWhite.main,
              '&:hover': {
                backgroundColor: globalTheme.palette.appWhite.main,
              },
            },
          },
        },
      },
    },

    MuiTypography: {
      styleOverrides: {
        root: {
          '&.dialog-btn-no-text': {
            width: '26px',
            height: '24px',
            fontSize: '20px',
            fontWeight: 300,
            lineHeight: 'normal',
            letterSpacing: 'normal',
            textTransform: 'none',
            color: globalTheme.palette.appWhite.main,
          },

          '&.dialog-btn-yes-text': {
            width: '32px',
            height: '24px',
            fontSize: '20px',
            fontWeight: 300,
            lineHeight: 'normal',
            letterSpacing: 'normal',
            textTransform: 'none',
            color: globalTheme.palette.black.main,
          },
        },
      },
    },
  },
});
